import { Box } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import theme from 'utils/theme';

import { ValueProps } from './types';

const useStyles = makeStyles(() => ({
  textWithLines: {
    whiteSpace: 'pre',
  },
}));

const getNumber = (value: string) => {
  const num = parseFloat(value?.toString().replace(/,/g, '') || '0');
  return num;
};

function getColor(value: string) {
  const num = getNumber(value);
  return num < 0 ? theme.palette.error.main : theme.palette.text.primary;
}

export function Value({ symbol, symbolPosition, value }: ValueProps) {
  const classes = useStyles();

  let valueToFormat;
  let valueToShow = '';

  function formattedValue(finalValue: string) {
    return Number(finalValue).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  if (value && typeof value === 'number') {
    valueToFormat = value;
  } else if (value && typeof value === 'string') {
    if (value.includes(',')) {
      valueToFormat = parseFloat(value.replace(/,/g, ''));
    } else if (value.includes('|')) {
      valueToFormat = value.split('|').join('\n');
    } else {
      valueToFormat = value;
    }
  }

  const isNegative = valueToFormat && Number(valueToFormat) < 0;

  if (valueToFormat && isNegative) {
    valueToShow = valueToFormat.toString().slice(1);
  } else if (valueToFormat && !isNegative) {
    valueToShow = valueToFormat.toString();
  } else {
    valueToShow = '';
  }
  if (symbol && symbolPosition === 'left') {
    if (isNegative) {
      valueToShow = `-${symbol}${formattedValue(valueToShow)}`;
    } else {
      valueToShow = `${symbol}${formattedValue(valueToShow)}`;
    }
  }
  if (symbol && symbolPosition === 'right') {
    if (isNegative) {
      valueToShow = `-${formattedValue(valueToShow)}${symbol}`;
    } else {
      valueToShow = `${formattedValue(valueToShow)}${symbol}`;
    }
  }

  return (
    <Box className={classes.textWithLines} color={getColor(value)}>
      {valueToShow}
    </Box>
  );
}
